import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class EvisionCameraConfigurationRoute extends AuthenticatedRoute {}
